<div class="container dashboard_card fm_padding dc_fixed" id="divpcontainer" *ngIf="_show">

    <div class="dc_header">
        <span></span>
        <h3>{{this._s_id==3?"Presentation Fixed":"Appointment"}}</h3>
        <button (click)="Close()"><i class="icon-close"></i></button>
    </div>

    <div class="add_cust_card" >

        <div class="acc_show_card" >

          <div class="lcta_tbox" [ngClass]="{'error': this.state.deal.iserr}"  id="div_deal"  *ngIf="this.drpDealList.length>0">
            <span>Deal<span>*</span></span>
            <ng-multiselect-dropdown id="drpdeal" class="ddb_lst_add_card" *ngIf="Showdrp" [(ngModel)]="SelectedDealList"
                [placeholder]="'Select Deal'"
                [settings]="dropdownSettings"
                [data]="drpDealList"
                (onSelect)="this.state.deal.iserr=false;DealAddSelect($event)"
                (onDeSelect)="DealRemoveSelect($event)"
                >
            </ng-multiselect-dropdown>
            <span class="error_txt" *ngIf=" this.state.deal.iserr">{{this.state.deal.err_txt}}</span>
        </div>


        <ng-container *ngFor="let obj of this.LoopList; let ind = index;">
            <ng-container *ngIf="ind!=0">

                <div class="radio_card">
                    <input type="checkbox" name="followupPointsradio_RadioList" id="cbx_sabove_{{ind}}"
                    [(ngModel)]="obj.cbxSameasabove" (change)="SameasAbove(obj,ind)"  />
                    <label for="cbx_sabove_{{ind}}">Same as above</label>
                </div>
            </ng-container>

            <div class="cmc_inner_card">

                <h2 *ngIf="this.drpDealList.length>0">{{obj.name}}</h2>

                <div class="cic_sub_card">

                    <ng-container >
                        <div class="lcta_tbox" id="div_mt_{{ind}}" [ngClass]="{'error': obj.state.meetingType.iserr}">
                            <span>Meeting Type</span>
                            <div class="">
                                <select2 [data]="this.meetingTypeList"
                                [customSearchEnabled]="false"
                                id="drppopupmeetingType" (click)="MFocus('div_mt_',ind)"  [resettable]="true"
                                [(ngModel)]="obj.state.meetingType.value" [placeholder]="'Select'"
                                (open)=" obj.state.meetingType.iserr=false" > </select2>

                                <!-- <select  (click)="MFocus('div_mt_',ind)"
                                    (change)=" obj.state.meetingType.iserr=false"
                                    [(ngModel)]="obj.state.meetingType.value" id="drppopupmeetingType">
                                    <option value="0">Select </option>
                                    <ng-container *ngFor="let obj of this.meetingTypeList">
                                    <option value="{{obj.id}}">{{obj.name}}</option>
                                    </ng-container>
                                </select> -->
                            </div>
                            <span class="error_txt" *ngIf="obj.state.meetingType.iserr">{{obj.state.meetingType.err_txt}}</span>
                        </div>

                        <div class="lcta_tbox"  id="div_m_{{ind}}" *ngIf="obj.state.meetingdate" [ngClass]="{'error': obj?.state?.meetingdate?.iserr}">
                            <span>When<span>*</span></span>
                            <mat-form-field>
                                <input matInput  (click)="MFocus('div_m_',ind)"   [min]="this.minDate" [max]="this.maxDate" [ngxMatDatetimePicker]="picker_ind"
                                (dateChange)="obj.state.meetingdate.iserr=false"
                                placeholder="Selse Date & Time" [(ngModel)]="obj.state.meetingdate.value" (click)="Callopen_cal(picker_ind)">
                                <mat-datepicker-toggle matSuffix [for]="$any(picker_ind)"></mat-datepicker-toggle>
                                <ngx-mat-datetime-picker #picker_ind [showSpinners]="true" ></ngx-mat-datetime-picker>
                            </mat-form-field>
                            <span class="error_txt">{{obj.state.meetingdate.err_txt}}</span>
                        </div>                    
                        <div *ngIf="this.isAppointmentAreaFLG" class="lcta_tbox"  id="div_ar_{{ind}}" [ngClass]="{'error': obj.state.area.iserr}" id="divStep1BusinessName">
                            <span>Where<span>*</span></span>
                            <input type="text" class="tbox "  (click)="MFocus('div_ar_',ind)"  [(ngModel)]="obj.state.area.value"  [cMaxLength]="'100'" name="" id="txtBusinessName"
                            placeholder="Type Area" on-focus="obj.state.area.iserr=false">
                            <span class="error_txt">{{obj.state.area.err_txt}}</span>
                        </div>                    
                        <div  class="lcta_tbox" id="div_c_{{ind}}" [ngClass]="{'error': obj.state.whomtomeet.iserr}" >
                          <span>Who<span></span></span>
                          <ng-multiselect-dropdown id="divmselc_{{ind}}"   *ngIf="Showdrp" [(ngModel)]="obj.SelectedMeetingList"
                              [placeholder]="'Select'"
                              [settings]="dropdownSettings"
                              [data]="contactList"
                              (onSelect)="obj.state.whomtomeet.iserr=false;onItemSelect($event,ind)"
                              >
                          </ng-multiselect-dropdown>
                          <span class="error_txt" *ngIf="obj.state.whomtomeet.iserr">{{obj.state.whomtomeet.err_txt}}</span>
                      </div>



                        <div class="textarea_card">
                            <span>What</span>
                            <textarea name=""    placeholder="Comments" cols="30" rows="10"  [(ngModel)]=obj.state.comments.value [cMaxLength]="'100'"></textarea>
                        </div>
                    </ng-container>

                </div>

            </div>





        </ng-container>

        </div>

        <button (click)="Save()" class="fixed_btn">SAVE</button>

    </div>

</div>

<!--

<div class="popupu_card ci_popup_card pop_active_card" id="divAddMeetingTypePopup" *ngIf="_show">

  <div class="popup_inner" >

      <a href="javascript:void(0)" (click)="Close()" class="pc_close_btn"><i class="icon-close"></i></a>

      <div class="ci_popup_txt_area">
           <p class="cpta_img cpi_sm"><img src="assets/images/add_icon.svg" alt=""></p>

           <h2>
            {{this._s_id==3?"Presentation Fixed":"Appointment"}}
            </h2>

          <div class="cpta_mh_card"  id="divpcontainer">

              <div class="ppuc_tbox_grid">



              </div>

          </div>

               <div class="mdc_date_tbox">
                 When - date time
                  To Whom - dropdown
                  Meeting type - dropdown
                  Comments - Text area
              </div>
      </div>
      <div class="ci_popup_btn_area">
          <button (click)="Cancel()">CLEAR</button>
          <button (click)="Save()">SAVE</button>
      </div>
  </div>
</div> -->
<!-- <app-ContactPopup [customerid]="customerid" [parentState]="this.state" #addcontactpopuppage
(Submit_Event)="Submit($event)"></app-ContactPopup> -->
<!-- <app-ContactPopup [customerid]="customerid" [parentState]="this.state" #addcontactpopuppage
(Submit_Event)="Submit($event)"></app-ContactPopup> -->
